import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { Banner, messageOf } from "./ui";

type DevUser = { email: string; display_name: string; role: string };

export function LoginPage() {
  const navigate = useNavigate();
  const [users, setUsers] = useState<DevUser[]>([]);
  const [mode, setMode] = useState<"development" | "staging" | "access" | null>(null);
  const [ownerEmail, setOwnerEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState<string | null>(null);

  useEffect(() => {
    api<{ mode: "development" | "staging" | "access"; owner_email: string }>("/api/auth/config")
      .then((config) => {
        setMode(config.mode);
        setOwnerEmail(config.owner_email);
        if (config.mode !== "development") return;
        return api<{ users: DevUser[] }>("/api/auth/dev-users").then((result) => setUsers(result.users));
      })
      .catch((reason: unknown) => setError(messageOf(reason)));
  }, []);

  async function signIn(email: string) {
    setPending(email);
    setError(null);
    try {
      await api("/api/auth/dev-login", { method: "POST", body: JSON.stringify({ email }) });
      navigate("/");
    } catch (reason) {
      setError(messageOf(reason));
    } finally {
      setPending(null);
    }
  }

  return (
    <div className="login">
      <section className="panel">
        <h1>1234 MASTER</h1>
        <p className="lede">
          {mode === "staging"
            ? "Σύνδεση με email και κωδικό. Ο ιδιοκτήτης χρησιμοποιεί τον κωδικό του staging. Οι υπόλοιποι χρησιμοποιούν τον κωδικό που ορίστηκε στον λογαριασμό τους."
            : "Σύνδεση με ταυτότητα ανάπτυξης. Αυτές οι συνεδρίες γίνονται δεκτές μόνο όσο το περιβάλλον είναι development. Μια κεφαλίδα email δεν είναι σύνδεση."}
        </p>
        <Banner error={error} />
        {mode === "staging" ? (
          <form
            className="stack"
            onSubmit={(event) => {
              event.preventDefault();
              const data = new FormData(event.currentTarget);
              setPending("staging");
              setError(null);
              void api("/api/auth/staging-login", {
                method: "POST",
                body: JSON.stringify({ email: String(data.get("email") ?? ""), password: String(data.get("password") ?? "") }),
              })
                .then(() => navigate("/"))
                .catch((reason: unknown) => setError(messageOf(reason)))
                .finally(() => setPending(null));
            }}
          >
            <label>Email<input name="email" type="email" autoComplete="username" defaultValue={ownerEmail} required /></label>
            <label>Κωδικός<input name="password" type="password" autoComplete="current-password" required /></label>
            <button type="submit" disabled={pending !== null}>{pending ? "Σύνδεση…" : "Σύνδεση"}</button>
          </form>
        ) : null}
        {mode === "development" && users.length === 0 && !error ? <p>Δεν έχουν οριστεί ακόμη ταυτότητες προσωπικού.</p> : null}
        <div className="stack">
          {users.map((user) => (
            <button key={user.email} type="button" disabled={pending !== null} onClick={() => void signIn(user.email)}>
              {pending === user.email ? "Σύνδεση…" : `${user.display_name} · ${user.role}`}
            </button>
          ))}
        </div>
        <p className="meta"><a href="/inquire">Φόρμα αιτήματος</a></p>
      </section>
    </div>
  );
}
